import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {StorageUtils} from "xmgoing-utils";
import {CurrentUtils} from "xmgoing-server";
import {_initVuexPropValFun} from "@/main-page/ctls/hooks/useVuexState";

function parseBoolFlag(val: any) {
  return val === true || val === 'true';
}

function evalColVuexProp(column: any, propName: string, record: any, state?: any) {
  const vuexStr = column?.[`${propName}Vuex`];
  if (!vuexStr) {
    return undefined;
  }
  const recordVal = record || {};
  const backVuex = ref({[propName]: false});
  _initVuexPropValFun(backVuex, {
    propName,
    vuexStr,
    recordData: recordVal,
    record: recordVal,
    state: state ?? usePageModelsStore().state,
  });
  return unref(backVuex)[propName];
}

function isRowCellEditable(column: any, record: any, state?: any) {
  if (!column) {
    return true;
  }
  const pageState = state ?? usePageModelsStore().state;
  const disabledFromVuex = evalColVuexProp(column, 'disabled', record, pageState);
  if (disabledFromVuex === true || disabledFromVuex === 'true') {
    return false;
  }
  if (column.showFun) {
    const aclInfo = {
      userId: StorageUtils.getSessionItem("curUserId"),
      tenantId: CurrentUtils.currentUser['tenantId'],
    };
    const vuexObj: any = {state: pageState};
    try {
      if (!column.showFunction) {
        column.showFunction = new Function("record", "aclInfo", "vuex", `return (${column.showFun})(record,aclInfo,vuex);`);
      }
      return column.showFunction(record, aclInfo, vuexObj) === true;
    } catch (e) {
      console.error(e, "======showFunction=====");
      return false;
    }
  }
  return true;
}

/**
 * 判断指定行上某列是否可编辑（column 应来自表格运行时列）
 */
export function isCellEditableForRecord(column: any, record: any, state?: any) {
  if (!column) {
    return false;
  }
  if (parseBoolFlag(column.disabled) || parseBoolFlag(column.readOnly)) {
    return false;
  }
  return isRowCellEditable(column, record, state);
}

export function findGridColumn(columns: any[], propId: string) {
  if (!columns?.length || !propId) {
    return undefined;
  }
  return columns.find((col: any) => col.propId === propId || col.dataIndex === propId);
}

/** 批量填充时视为有效值（null/undefined/空字符串均跳过） */
export function hasBatchFillValue(value: any) {
  return value != null && value !== '';
}

/** 判断列是否允许出现在批量填充表单中 */
export function isBatchEditableCol(
  column: any,
  options?: { showAllCol?: boolean; selectedRecords?: any[]; state?: any },
) {
  const {showAllCol = false, selectedRecords = [], state} = options || {};
  if (column.closeBatchFill === true || column.closeBatchFill === 'true') {
    return false;
  }
  if (showAllCol) {
    return true;
  }
  if (column.closeMoreEditor === true) {
    return false;
  }
  const typeText = `${column.propType || ''}${column.controlType || ''}`;
  if (typeText.indexOf('Editor') < 0) {
    return false;
  }
  if (!column.showFlag) {
    return false;
  }
  if (parseBoolFlag(column.disabled) || parseBoolFlag(column.readOnly)) {
    return false;
  }
  const pageState = state ?? usePageModelsStore().state;
  if (selectedRecords.length > 0) {
    return selectedRecords.some((record) => isRowCellEditable(column, record, pageState));
  }
  return true;
}

export function useDisabledFunHook({column, record}: any) {

    const pageModelsStore: any = usePageModelsStore();
    const {state} = storeToRefs(pageModelsStore);

    const disabledFun = computed(() => {
        if (unref(column).showFun) {
            const aclInfo = {
                userId: StorageUtils.getSessionItem("curUserId"),
                tenantId: CurrentUtils.currentUser['tenantId']
            };
            const vuexObj: any = {state: unref(state)}
            if (!unref(column).showFunction) {
                try {
                    unref(column).showFunction = new Function("record", "aclInfo", "vuex", `return (${unref(column).showFun})(record,aclInfo,vuex);`);
                    const res = unref(column).showFunction(unref(record), unref(aclInfo), vuexObj);
                    return res === true ? false : true;
                } catch (e) {
                    console.error(e, "======showFunction=====")
                }
            } else {
                const res = unref(column).showFunction(unref(record), unref(aclInfo), vuexObj);
                return res === true ? false : true;
            }
        }
        return false;
    })

    return {
        disabledFun
    }
}
